export const formatNumberWithSuffix = (number: number, t: (key: string) => string): string => {
  const suffixes = [
    { value: 1e6, suffix: t('m') },
    { value: 1e3, suffix: t('k') }
  ]

  // Handle suffixes (k, m) first
  for (const { value, suffix } of suffixes) {
    if (number >= value) {
      // Floor (not round) the abbreviation so it never reads HIGHER than
      // the real amount. toFixed(1) rounds half-up, which made e.g. a
      // 123,567 stake show "123.6k" (123,600) and appear to exceed
      // balance (QA-60249). For player-facing money we never want to
      // over-state — show slightly less, never more.
      const scaled = Math.floor((number / value) * 10) / 10
      const formatted = scaled.toFixed(1)
      // Remove .0 if present
      return formatted.endsWith('.0') ? formatted.slice(0, -2) + suffix : formatted + suffix
    }
  }

  // For small decimals (e.g., 0.0005 BTC), show enough digits for a non-zero value
  if (number > 0 && number < 1) {
    const neededDecimals = Math.max(2, -Math.floor(Math.log10(number)) + 1)
    const formatted = number.toFixed(neededDecimals)
    // Remove trailing zeros but keep at least one decimal digit
    return formatted.replace(/0+$/, '').replace(/\.$/, '')
  }

  // For regular numbers
  const formatted = number.toFixed(2)
  // Remove .00 if present
  return formatted.endsWith('.00') ? formatted.slice(0, -3) : formatted
}
